import CrewTypeSelect from "../../components/ui/dropdowns/CrewTypeSelect";
import useCrews from "./useCrews";
import TextInput from "../../components/ui/input/TextInput";
import Button from "../../components/ui/buttons/Button";
import { useEffect } from "react";
import Switch from "../../components/ui/switch/Switch";

const CrewForm = ({ mode, state, dispatch }) => {
  const {
    crewTypeSelectHandler,
    drillOperatorChangeHandler,
    foremanChangeHandler,
    foremanEmailChangeHandler,
    foremanPhoneChangeHandler,
    locatorChangeHandler,
    supervisorChangeHandler,
    submitHandler,
    setMode,
    enabledStatusToggle,
  } = useCrews({ state, dispatch });

  useEffect(() => {
    setMode(mode);
    // eslint-disable-next-line
  }, [state.selectedCrew]);

  return (
    <>
      <CrewTypeSelect
        identifier="crewTypeSelect"
        value={state.selectedCrewType}
        selectHandler={crewTypeSelectHandler}
        required={true}
      />
      <TextInput
        identifier="supervisor"
        label="Supervisor"
        onChange={supervisorChangeHandler}
        value={state.supervisor}
        type="text"
      />
      <TextInput
        identifier="drillOperator"
        label="Drill Operator"
        onChange={drillOperatorChangeHandler}
        value={state.drillOperator}
        type="text"
      />
      <TextInput
        identifier="locator"
        label="Locator"
        onChange={locatorChangeHandler}
        value={state.locator}
        type="text"
      />
      <TextInput
        identifier="foreman"
        label="Foreman - Cannot be changed."
        onChange={foremanChangeHandler}
        value={state.foreman}
        type="text"
        required={state?.selectedCrew?.value?.id === 0}
        readonly={state?.selectedCrew?.value?.id !== 0}
      />
      <TextInput
        label={"Foreman Phone Number"}
        placeholder={"xxx-xxx-xxxx"}
        identifier={"phoneNumber"}
        onChange={foremanPhoneChangeHandler}
        value={state.foremanPhone}
        type="tel"
        error={state.foremanPhoneError}
        errorText={"Required format: xxx-xxx-xxxx."}
      />
      <TextInput
        label={"Foreman Email"}
        placeholder={"Email"}
        identifier={"email"}
        onChange={foremanEmailChangeHandler}
        value={state.foremanEmail}
        type="email"
        error={state.foremanEmailError}
        errorText={"Invalid email."}
      />

      {state.mode === "Edit" && (
        <Switch
          label={state.enabledStatus ? `Enabled: True` : `Enabled: False`}
          identifier={"status"}
          isChecked={state.enabledStatus}
          setIsChecked={enabledStatusToggle}
        />
      )}
      <Button
        text={`Submit ${mode}`}
        onClick={submitHandler}
        disabled={!state.formValid}
      />
    </>
  );
};

export default CrewForm;
